"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPackageCostForDate = void 0;
const dayjs = require("dayjs");
const getPackageCostForDate = (date, pkg) => {
    if (!date) {
        date = dayjs().toISOString();
    }
    if (!pkg)
        return 0;
    const room_prices = pkg?.room?.prices.find((price) => {
        return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
            dayjs(date).unix() <= dayjs(price.to_date).unix());
    });
    if (!room_prices) {
        return 0;
    }
    const course_prices = pkg.courses.reduce((a, b) => Number(a) +
        Number(b?.prices?.green_fees?.find((price) => {
            return (dayjs(date).unix() >= dayjs(price.from_date).unix() &&
                dayjs(date).unix() <= dayjs(price.to_date).unix());
        })?.sell_price || 0), 0);
    const total = () => {
        let t = 0;
        t += (room_prices.total / pkg.room.room_basis) * pkg.number_of_nights;
        if (pkg.airport_transfer) {
            t +=
                pkg.airport_return_transfer_price *
                    (1 - (pkg.airport_transfer_discount || 0) / 100);
        }
        if (pkg.course_transfer) {
            t +=
                pkg.courses.reduce((a, b) => Number(a) + Number(b.prices.transfer_price), 0) *
                    (1 - (pkg.golf_transfer_discount || 0) / 100);
        }
        t += course_prices * (1 - (pkg.golf_discount || 0) / 100);
        return t;
    };
    if (course_prices === 0 || room_prices.total === 0) {
        return 0;
    }
    // make sure the number is rounded and shows no decimals
    return total();
};
exports.getPackageCostForDate = getPackageCostForDate;
